import React from "react";

// Where an asset lands after a move, spelled out as the nav path the admin
// will click through. Keep in step with NavigationSideBar / the two rails.
export const DESTINATIONS = {
  training: {
    form: "Training > Training Content > Forms",
    swipe_deck: "Training > Training Content > Swipe Decks",
  },
  engagement: {
    form: "Engagement > Surveys",
    swipe_deck: "Engagement > Swipe Decks",
  },
};

/**
 * Confirm for moving a form or swipe deck between the Training and Engagement
 * tabs. Always names the destination (the asset disappears from this list, so
 * the admin needs to know where to find it), and lists anything the server
 * resets on the way (`losses`, only for training form -> Engagement).
 * Styled like SwipeDecksDisplay's DeleteConfirm.
 */
function MoveAssetConfirm({ name, assetType, toPurpose, losses = [], onCancel, onConfirm }) {
  const toLabel = toPurpose === "engagement" ? "Engagement" : "Training";
  const destination = DESTINATIONS[toPurpose][assetType];
  const noun = assetType === "form" ? "form" : "deck";
  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center px-4"
      onClick={onCancel}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold text-slate-900 mb-2">Move to {toLabel}?</h3>
        <p className="text-sm text-slate-500 mb-3">
          <span className="font-medium text-slate-900">{name || `Untitled ${noun}`}</span>{" "}
          will leave this list and appear under{" "}
          <span className="font-medium text-slate-900">{destination}</span>.
          {toPurpose === "engagement"
            ? " Anyone with a link can then fill it, no login."
            : " It can then be embedded in sections and assigned as training."}
        </p>
        {losses.length > 0 && (
          <>
            <p className="text-sm text-slate-500 mb-2">
              Its training settings are removed and can't be restored by moving it
              back:
            </p>
            <ul className="text-sm text-slate-700 list-disc pl-5 mb-4 space-y-1">
              {losses.map((l) => (
                <li key={l}>{l}</li>
              ))}
            </ul>
          </>
        )}
        <div className="flex items-center justify-end gap-2 mt-2">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 rounded-lg text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-violet-700 hover:bg-violet-800 transition-colors"
          >
            Move to {toLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default MoveAssetConfirm;
